import React from 'react';
import { buildBreadcrumbTrail } from '../config/routeConfig';

interface BreadcrumbsProps {
  currentPath: string;
  onNavigate: (routeId: string, params?: Record<string, string>, data?: Record<string, any>) => void;
  contextData?: Record<string, any>;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ currentPath, onNavigate, contextData = {} }) => {
  // Build breadcrumb trail dynamically from route config
  const breadcrumbs = buildBreadcrumbTrail(currentPath, contextData);

  const handleBreadcrumbClick = (routeId: string) => {
    // Clear context data when navigating back
    onNavigate(routeId, {}, {});
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '0',
      fontSize: '0.8rem',
      fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      color: '#5A6080',
    }}>
      <i className="pi pi-home" style={{ fontSize: '0.9rem', color: '#14267A' }}></i>
      
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={`${item.id}-${index}`}>
          {index > 0 && (
            <i className="pi pi-chevron-right" style={{ 
              fontSize: '0.7rem', 
              color: '#C6CDE8',
              margin: '0 4px'
            }}></i>
          )}
          
          {index === breadcrumbs.length - 1 ? (
            // Current page - not clickable
            <span style={{
              color: '#14267A',
              fontWeight: '600',
            }}>
              {item.label}
            </span>
          ) : (
            // Previous pages - clickable
            <button
              onClick={() => handleBreadcrumbClick(item.id)}
              style={{
                background: 'none',
                border: 'none',
                color: '#5A6080',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '6px',
                transition: 'all 0.2s ease',
                fontSize: '0.8rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#E8EBF8';
                e.currentTarget.style.color = '#14267A';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'none';
                e.currentTarget.style.color = '#5A6080';
              }}
            >
              {item.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;